import env from "$lib/env";
import { get } from "svelte/store";
import settings from "$lib/state/settings";

export const currentApiURL = () => {
    const processingSettings = get(settings).processing;
    const customInstanceURL = processingSettings.customInstanceURL;

    if (processingSettings.enableCustomInstances && customInstanceURL.length > 0) {
        return new URL(customInstanceURL).origin;
    }

    // Keep the configured path for self-hosted deployments. The stock
    // implementation reduces the URL to its origin, which makes it impossible
    // to host the web app and API on distinct paths of the same domain.
    return new URL(env.DEFAULT_API!).href.replace(/\/+$/, "");
}
